import '../../Grid.css';var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import "../../Utilities.js";
import Container from "react-bootstrap/Container";
import "./Grid.types.js";
import { GridRow } from "./GridRow.js";
import { GridCol } from "./GridCol.js";
import { css } from "@fluentui/utilities";
const bootstrap = "";
const defaultClassName = "ane-Grid";
class Grid extends React.Component {
  render() {
    const _a = this.props, { children, className, rows, fluid = true } = _a, rest = __objRest(_a, ["children", "className", "rows", "fluid"]);
    return /* @__PURE__ */ jsxs(Container, __spreadProps(__spreadValues({}, rest), { fluid, className: css(defaultClassName, className), children: [
      !!rows && rows.map((row, i) => /* @__PURE__ */ jsx(GridRow, { children: row.columns.map((col) => /* @__PURE__ */ jsx(GridCol, { xs: col.xs, sm: col.sm, md: col.md, lg: col.lg, xl: col.xl, children: col.content }, col.key)) }, i)),
      children
    ] }));
  }
}
export {
  Grid,
  Grid as default
};
//# sourceMappingURL=Grid.js.map
